<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="receipt-container" #receiptCard>
      
        <img src="brand/logo.jpeg" width="60">
          
        @if (this.receipt?.status=='PAID') {
          <div class="step-icon success">
            <i class="fa fa-check-circle text-center"></i>
          </div>
        }
        @if (this.receipt?.status=='FAILED') {
          <div class="step-icon failed">
            <i class="fa fa-check-circle text-center"></i>
          </div>
        }
        @if (this.receipt?.status!='FAILED') {
          <div class="receipt-header text-center fs-1 mb-4 d-flex justify-content-center">{{receiptType}}</div>
        }
        @if (this.receipt?.status=='FAILED') {
          <span class="receipt-header text-center fs-1 mb-4 d-flex justify-content-center text-danger">Echec paiment</span>
        }
        @if (this.receipt?.status=='PENDING') {
          <span class="receipt-header text-center fs-1 mb-4 d-flex justify-content-center text-danger">Opération en cours de traitement</span>
        }

        <div class="mb-4 receipt-details">

          <h5 class="d-flex justify-content-center">Details Transaction</h5>

          @if (receipt?.transactionType=='REDEVANCE_IMMO') {
            <div  class="receipt-row">
              <span class="label" >Promoteur : </span>
              <span class="value">{{receipt?.merchantName}} </span>
            </div>
            <div  class="receipt-row">
              <span class="label" >Nom du client : </span>
              <span class="value">{{receipt?.details?.['customerName']}} </span>
            </div>
            <div  class="receipt-row">
              <span class="label" >Produit : </span>
              <span class="value">{{receipt?.details?.['productName']}} </span>
            </div>
          }
          @if (receipt?.transactionType=='SCHOOLPAY') {
            <div  class="receipt-row">
              <span class="label" >Etablissement : </span>
              <span class="value">{{receipt?.merchantName}} </span>
            </div>
            <div class="receipt-row">
              <span class="label">Nom élève : </span>
              <span class="value">{{receipt?.bill?.studentName}} </span>
            </div>
            <div class="receipt-row">
              <span class="label">Code élève : </span>
              <span class="value">{{receipt?.bill?.idStudent}} </span>
            </div>
          
          @if (classe&& classe.yearlyFee) {
            <div class="receipt-row">
              <span class="label">Frais annuel: </span>
              <span class="value">{{classe.yearlyFee}} </span>
            </div>
          }
          @if (classe && classe.apecAmount>0) {
            <div class="receipt-row">
              <span class="label">APEC: </span>
              <span class="value">{{classe.apecAmount}} </span>
            </div>
          }
          @if (classe && classe.firstMonthAmount>0) {
            <div class="receipt-row">
              <span class="label">Scolarité Octobre: </span>
              <span class="value">{{classe.firstMonthAmount}} </span>
            </div>
          }


          @for (item of classe?.otherItems ?? []; track item) {
            <div class="receipt-row">
              <span class="label">{{item.libelle}}: </span>
              <span class="value">{{item.value}} </span>
            </div>
          }
        }
        @if(receipt?.transactionType==='TUTOR_OFFER_PAY') {
           <div class="receipt-row">
              <span class="label">Tuteur: </span>
              <span class="value">{{receipt?.details?.['productOwner']}} </span>
            </div>
             <div class="receipt-row">
              <span class="label">Cours: </span>
              <span class="value">{{receipt?.details?.['productName']}} </span>
            </div>
             <div class="receipt-row">
              <span class="label">Nom du client: </span>
              <span class="value">{{receipt?.details?.['customerName']}} </span>
            </div>
        }

          <div class="receipt-row">
            <span class="label">Reference transaction:</span>
            <span class="value">{{receipt?.reference}}</span>
          </div>
          @if (this.receipt?.status=='PAID'||this.receipt?.status=='VALIDATED') {
            <div class="receipt-row">
              <span class="label">Date:</span>
              <span class="value">{{receipt?.paymentDate}}</span>
            </div>
          }
          @if (receipt?.paymentNetwork) {
            <div class="receipt-row">
              <span class="label">Moyen de paiement:</span>
              <span class="value">{{receipt?.paymentNetwork}}</span>
            </div>
          }
          @if (receipt?.bill?.echeances?.length) {
            <div class="receipt-row">
              <span class="label">Échéances:</span>
              <span class="value">
                @for (echeance of receipt?.bill?.echeances ?? []; track $index) {
                  <span>{{echeance}} </span>
                }
              </span>
            </div>
          }
          <div class="receipt-row">
            <span class="label">Montant : </span>
            <span class="total-amount">{{receipt?.amount}} {{receipt?.currencyCode}}</span>
          </div>
          <div class="receipt-row">
            <span class="label">Frais : </span>
            <span class="total-amount">{{receipt?.fees}} {{receipt?.currencyCode}}</span>
          </div>
           <div class="receipt-row">
            <span class="label">Total : </span>
            <span class="total-amount">{{total}} {{receipt?.currencyCode}}</span>
          </div>
          @if(taxes.length > 0){

            @for (tax of taxes; track tax) {
              <div class="receipt-row">
                <span class="label">{{tax[0]}} :</span>
                <span class="value">{{tax[1]}} {{receipt?.currencyCode}}</span>
              </div>
            }

          }
          

        </div>


      </div>

      <!--div class="share-actions mt-3 d-flex flex-wrap gap-2 justify-content-center">
        <button type="button" class="btn btn-primary" (click)="shareReceipt()" [disabled]="isCapturing">
          @if (!isCapturing) {
            <i class="fa fa-share-alt me-1"></i> Partager
          } @else {
            <span class="spinner-border spinner-border-sm me-1"></span> Génération...
          }
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="downloadReceiptImage()" [disabled]="isCapturing">
          <i class="fa fa-download me-1"></i> Image
        </button>
        <button type="button" class="btn btn-whatsapp" (click)="shareViaWhatsApp()" title="Partager via WhatsApp">
          <i class="fa fa-whatsapp me-1"></i> WhatsApp
        </button>
        <button type="button" class="btn btn-telegram" (click)="shareViaTelegram()" title="Partager via Telegram">
          <i class="fa fa-telegram me-1"></i> Telegram
        </button>
      </div-->
      
    </div>
  </div>
</div>


